import { googletag } from "./loader";
import { data } from "@escapio/shared/state/payload";
import { langId } from "@escapio/shared/l10n/lang-id";

googletag.cmd.push(() => {
	const pubads = googletag.pubads().setTargeting("langId", langId);
	if (data.page_search_type == "hotel_type") {
		pubads.setTargeting("hotelTypeId", `${data.listId}`);
	} else if (data.page_search_type == "combi") {
		const [geoId, hotelTypeId] = data.listId.split("|");
		pubads.setTargeting("geoId", geoId);
		pubads.setTargeting("hotelTypeId", hotelTypeId);
	} else {
		pubads.setTargeting("geoId", `${data.listId}`);
	}

	googletag.enableServices();

	document.addEventListener("hotelListPaginated", () => {
		googletag.pubads().refresh();
	});
});
